import * as React from 'react'

function SvgIconPdf(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#icon_pdf_svg__clip0)">
        <path
          d="M15.3 0H5.1a1.7 1.7 0 00-1.7 1.7v10.2a1.7 1.7 0 001.7 1.7h10.2a1.7 1.7 0 001.7-1.7V1.7A1.7 1.7 0 0015.3 0zM8.075 6.375A1.275 1.275 0 016.8 7.65h-.85v1.7H4.675v-5.1H6.8a1.275 1.275 0 011.275 1.275v.85zm4.25 1.7A1.275 1.275 0 0111.05 9.35H8.925v-5.1h2.125a1.275 1.275 0 011.275 1.275v2.55zm3.4-2.55H14.45v.85h1.275V7.65H14.45v1.7h-1.275v-5.1h2.55v1.275zm-9.775.85h.85v-.85h-.85v.85zM1.7 3.4H0v11.9A1.7 1.7 0 001.7 17h11.9v-1.7H1.7V3.4zm8.5 4.675h.85v-2.55h-.85v2.55z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="icon_pdf_svg__clip0">
          <path fill="#fff" d="M0 0h17v17H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgIconPdf
